import BaseScene from './BaseScene';
import SliderButtonHorizontal from '../components/SliderButtonHorizontal';
import ButtonSprite from '../components/ButtonSprite';
import translate from '../components/LanguageManager';

export default class Settings extends BaseScene {

    private soundVolume = 0;
    private gameSpeed = 0;
    private userName = '';
    private inputUserName: any = null;
    private soundSliderBar?: SliderButtonHorizontal;
    private speedSliderBar?: SliderButtonHorizontal;

    constructor() {
        super({key: 'Settings'});
    }

    public init() {
        super.init();
        this.soundVolume = this.getBootloaderScene().AppData.settings.soundVolume;  
        this.gameSpeed = this.getBootloaderScene().AppData.settings.gameSpeed;  
        this.userName = this.getBootloaderScene().AppData.user.name;  
    }

    public preload() {
        this.load.html('inputForm', 'assets/html/form.html');
    }

    public create() {
        super.create();

        // BG
        this.add.rectangle(this.width / 2, this.height / 2, 2000, 2000, parseInt('000000', 16)).setAlpha(0.7);

        // Panel
        const panel = this.add.image(0, 0,'game_panel_main_big_02').setScale(1);

        const title = this.add.text(0, -242, translate.key('Settings'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 56,
                color: '#fff'
            })
            .setStroke('#212121', 6);

        const soundDescription = this.add.text(0, -124, translate.key('settings_text_1'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 22,
                color: '#3d3d3d'
            });

        const speedDescription = this.add.text(0, -42, translate.key('settings_text_2'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 22,
                color: '#3d3d3d'
            });

        const userNameDescription = this.add.text(0, 40,translate.key('settings_text_3'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'soupofjustice',
                fontSize: 22,
                color: '#3d3d3d'
            });

        const policyLink = this.add.text(0, 134,translate.key('settings_text_4'))
            .setOrigin(0.5)
            .setStyle({ 
                fontFamily: 'supersonic',
                fontSize: 18,
                color: '#585858'
            })
            .setInteractive({ useHandCursor: true })
            .on('pointerup', () => {
                window.open('https://phalanx.optimbyte.com/privacy-policy/', '_blank');
            });

        const backButton = new ButtonSprite(this, -10, 240, 'button_back', 2, () => this.backToMainMenu());

        const container = this.add.container(this.width / 2, -300).add([panel, title, soundDescription, speedDescription, userNameDescription, policyLink, backButton]);

        // Slider Bars
        this.soundSliderBar = new SliderButtonHorizontal(
            this,
            this.width / 2,
            -400,
            this.soundVolume,
            this.setSoundVolumePercentage.bind(this),
            'button_red_green',
            0.5,
            0.4
        );

        this.speedSliderBar = new SliderButtonHorizontal(
            this,
            this.width / 2,
            -300,
            this.gameSpeed,
            this.setGameSpeedPercentage.bind(this),
            'slide_button_selector',
            0.5,
            0.4
        );

        // Form
        const form = this.add.dom((this.width / 2) -130 , -280)
            .setOrigin(0)
            .createFromCache('inputForm');
        this.inputUserName = form.getChildByName('user-name');
        this.inputUserName.placeholder = translate.key('settings_text_5');
        if (this.inputUserName) {
            this.inputUserName.value = this.userName;
        }
        this.inputUserName.addEventListener('keydown', (event: any) => {
            if (event.key === 'Enter') {
                this.inputUserName.blur();
            }
        });
        document.addEventListener('click', (event) => {
            if (!this.inputUserName.contains(event.target)) {
                this.inputUserName.blur();
            }
        });

        // Tweens
        this.soundSliderBar.applyTweens({
            y: 368,
            targets: [],
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });
        this.speedSliderBar.applyTweens({
            y: 450,
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });
        this.tweens.add({
            y: 460,
            targets: [container],
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });
        this.tweens.add({
            y: 514,
            targets: [form],
            ease: 'Sine.easeInOut',
            duration: 500,
            repeat: 0,
        });
    }

    private setSoundVolumePercentage(barPercentage: number): void {
        this.soundVolume = barPercentage;
        this.getBootloaderScene().soundManager.setVolume(barPercentage); 
    }

    private setGameSpeedPercentage(barPercentage: number): void {
        this.gameSpeed = barPercentage;
    }

    private backToMainMenu() {
        this.getBootloaderScene().setSoundVolume(this.soundVolume);
        this.getBootloaderScene().setGameSpeed(this.gameSpeed);
        this.getBootloaderScene().setUserName(this.inputUserName.value);
        this.getBootloaderScene().stopScene('Settings');
        this.scene.resume('MainMenu');
    }

    public update(): void {

        // Slider Button
        this.soundSliderBar?.update();
        this.speedSliderBar?.update();

    }
}
